import { apikeyConstants, userConstants } from "../constants";

// Non-secret API-key details only. The raw key is never stored here: the store
// is console.logged on every action by src/helpers/logger.js.
// key: undefined (not fetched yet) | { exists: false } | { exists: true, prefix, ... }
const initialState = { loading: false, mutating: false, error: undefined, key: undefined };

// Whitelist the documented GET fields, so nothing else (and in particular no
// raw key) can end up in the store even if the response ever carried it.
function toKeyDetails(data) {
    if (!data || !data.exists) {
        return { exists: false };
    }
    return {
        exists: true,
        prefix: data.prefix,
        createdon: data.createdon,
        lastusedat: data.lastusedat === undefined ? null : data.lastusedat,
        limited: data.limited,
        postsperday: data.postsperday,
        remaining: data.remaining === undefined ? null : data.remaining
    };
}

export function apikey(state = initialState, action) {
    switch (action.type) {
        case apikeyConstants.APIKEY_GET_REQUEST:
            return { ...state, loading: true, error: undefined };
        case apikeyConstants.APIKEY_GET_SUCCESS:
            return { ...state, loading: false, error: undefined, key: toKeyDetails(action.payload) };
        case apikeyConstants.APIKEY_GET_FAILURE:
            return { ...state, loading: false, error: { status: action.payload.status, op: 'get' } };

        case apikeyConstants.APIKEY_GENERATE_REQUEST:
        case apikeyConstants.APIKEY_REVOKE_REQUEST:
            return { ...state, mutating: true, error: undefined };
        case apikeyConstants.APIKEY_GENERATE_SUCCESS:
        case apikeyConstants.APIKEY_REVOKE_SUCCESS:
            return { ...state, mutating: false, error: undefined };
        case apikeyConstants.APIKEY_GENERATE_FAILURE:
            return { ...state, mutating: false, error: { status: action.payload.status, op: 'generate' } };
        case apikeyConstants.APIKEY_REVOKE_FAILURE:
            return { ...state, mutating: false, error: { status: action.payload.status, op: 'revoke' } };

        case apikeyConstants.APIKEY_CLEAR:
        case userConstants.LOGOUT:
            return initialState;
        default:
            return state;
    }
}
